const createPickMuiClasses = classNames => theme =>
    Object.keys(theme).reduce(
        (allowedClassNames, className) => (
            classNames.includes(className) ? { ...allowedClassNames, [className]: theme[className] } : allowedClassNames
        ),
        {}
    );

export default createPickMuiClasses;
